<circ-loader [isLoading]="isLoading"></circ-loader>
<div class="user-page substitute" *ngIf="!isLoading">
  <form class="k-form" [formGroup]="formGroup">
    <fieldset class="k-form-fieldset">
      <legend class="k-form-legend">{{ 'substitute.component.user.name' | i18n }} - {{ userName }}</legend>
      <kendo-formfield showErrors="initial">
        <kendo-label [for]="deputy" [text]="'substitute.component.user.deputy.label' | i18n"></kendo-label>
        <sp-people-picker #deputy [maxPeople]="1" formControlName="deputy"></sp-people-picker>
        <kendo-formhint>{{ 'substitute.component.user.deputy.hint' | i18n }}</kendo-formhint>
        <kendo-formerror>
          <div *ngIf="formGroup.controls.deputy.errors?.required">{{'substitute.component.user.deputy.error' | i18n }}</div>
        </kendo-formerror>
      </kendo-formfield>
      <kendo-formfield [showErrors]="'initial'">
        <kendo-label [for]="startDate" [text]="'substitute.component.user.startDate.label' | i18n"> </kendo-label>
        <kendo-datepicker  [title]="'substitute.component.user.startDate.label' | i18n" formControlName="startDate" #startDate required> </kendo-datepicker>
        <kendo-formhint>{{ 'substitute.component.user.startDate.hint' | i18n }}</kendo-formhint>
        <kendo-formerror>
          <div *ngIf="formGroup.controls.startDate.errors?.required">{{ 'substitute.component.user.startDate.required' | i18n }}</div>
        </kendo-formerror>
      </kendo-formfield>
      <kendo-formfield [showErrors]="'initial'">
        <kendo-label [for]="endDate" [text]="'substitute.component.user.endDate.label' | i18n"> </kendo-label>
        <kendo-datepicker [title]="'substitute.component.user.endDate.label' | i18n" formControlName="endDate" #endDate> </kendo-datepicker>
        <kendo-formhint>{{ 'substitute.component.user.endDate.hint' | i18n }}</kendo-formhint>
        <kendo-formerror>
          <div *ngIf="formGroup.controls.endDate.errors?.range">{{ 'substitute.component.user.endDate.range' | i18n:formGroup.controls.endDate.errors.range}}</div>
        </kendo-formerror>
      </kendo-formfield>
      <hr />
      <div class="k-form-buttons">
        <ece-btn-primary (click)="save()" [text]=" 'substitute.component.user.button.save' | i18n "></ece-btn-primary>
        <ece-btn (click)="abort()" [text]=" 'substitute.component.user.button.abort' | i18n"></ece-btn>
        &nbsp;
        <ece-btn (click)="delete()" [text]=" 'substitute.component.user.button.delete' | i18n"></ece-btn>
      </div>
    </fieldset>
  </form>
</div>
